import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { forgot, reset } from 'store/services/recover'
import * as authenticationDuck from 'store/ducks/authentication'
import { intl } from 'i18n'

// Actions
export const FORGOT_REQUEST = 'forgot/FORGOT_REQUEST'
export const FORGOT_SUCCESS = 'forgot/FORGOT_SUCCESS'
export const FORGOT_FAILURE = 'forgot/FORGOT_FAILURE'
export const RESET_REQUEST = 'forgot/RESET_REQUEST'
export const RESET_SUCCESS = 'forgot/RESET_SUCCESS'
export const RESET_FAILURE = 'forgot/RESET_FAILURE'

// Reducer
const INITIAL = {
  forgot: {
    sended: false,
    loading: false,
    errors: [],
  },
  reset: {
    reseted: false,
    loading: false,
    errors: [],
  },
}

export function reducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case FORGOT_REQUEST:
      return {
        ...state,
        forgot: {
          sended: false,
          loading: true,
          errors: [],
        },
      }
    case FORGOT_SUCCESS:
      return {
        ...state,
        forgot: {
          sended: true,
          loading: false,
          errors: [],
        },
      }
    case FORGOT_FAILURE:
      return {
        ...state,
        forgot: {
          sended: false,
          loading: false,
          errors: action.errors,
        },
      }
    case RESET_REQUEST:
      return {
        ...state,
        reset: {
          reseted: false,
          loading: true,
          errors: [],
        },
      }
    case RESET_SUCCESS:
      return {
        ...state,
        reset: {
          reseted: true,
          loading: false,
          errors: [],
        },
      }
    case RESET_FAILURE:
      return {
        ...state,
        reset: {
          reseted: false,
          loading: false,
          errors: action.errors,
        },
      }
    default:
      return state
  }
}

// Actions Creators
export const forgotRequest = (username) => ({
  type: FORGOT_REQUEST,
  username,
})

export const forgotSuccess = () => ({
  type: FORGOT_SUCCESS,
})

export const forgotFailure = (errors) => ({
  type: FORGOT_FAILURE,
  errors,
})

export const resetRequest = (token, plainPassword) => ({
  type: RESET_REQUEST,
  token,
  plainPassword,
})

export const resetSuccess = () => ({
  type: RESET_SUCCESS,
})

export const resetFailure = (errors) => ({
  type: RESET_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(forgotRequestEpic, resetRequestEpic)

export function forgotRequestEpic(action$) {
  return action$.ofType(FORGOT_REQUEST).mergeMap((action) =>
    Observable.ajax(forgot({ payload: { username: action.username } }))
      .map((res) => forgotSuccess())
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(forgotFailure(errors))
        } catch (e) {
          return Observable.of(forgotFailure([intl.formatMessage({ id: 'ducks.server' })]))
        }
      }),
  )
}

export function resetRequestEpic(action$) {
  return action$.ofType(RESET_REQUEST).mergeMap((action) =>
    Observable.ajax(reset({ payload: { token: action.token, plainPassword: action.plainPassword } }))
      .map((res) => resetSuccess())
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(resetFailure(errors))
        } catch (e) {
          return Observable.of(resetFailure([intl.formatMessage({ id: 'ducks.server' })]))
        }
      }),
  )
}
